import FBtnMDP, { BtnType } from "@/components/FBtnMDP";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FDateFieldMDP from "@/components/form/field/FDateFieldMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";

import FDebtRepaymentsMiniFormMDP from "./FDebtRepaymentsMiniFormMDP";
import FDependentExpensesFBudgetMiniFormMDP from "./FDependentExpensesFBudgetMiniFormMDP";
import FHardshipReasonFMiniFormMDP from "./FHardshipReasonFMiniFormMDP";
import FIncidentalExpensesFBudgetMiniFormMDP from "./FIncidentalExpensesFBudgetMiniFormMDP";
import FIncomeSourcesFBudgetMiniFormMDP from "./FIncomeSourcesFBudgetMiniFormMDP";
import FLifeStyleExpensesFBudgetMiniFormMDP from "./FLifeStyleExpensesFBudgetMiniFormMDP";
import FLivingExpensesFBudgetMiniFormMDP from "./FLivingExpensesFBudgetMiniFormMDP";
import FMiscExpensesFBudgetMiniFormMDP from "./FMiscExpensesFBudgetMiniFormMDP";
import FPersonalFMiniFormMDP from "./FPersonalFMiniFormMDP";
import FIEUnsecuredDebtFBudgetMiniFormMDP from './FIEUnsecuredDebtFBudgetMiniFormMDP';
export default class FBudgetFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  parent: any;
  constructor({
    taskRoot,
    parent,
    disabled,
  }: {
    taskRoot: any;
    parent: any;
    disabled: boolean;
  }) {
    super({
      myRefName: "budgetFormRef",
      disabled: disabled,
    });
    this.taskRoot = taskRoot;
    this.parent = parent;
    this.addField(
      new FPersonalFMiniFormMDP({ taskRoot: this.taskRoot, parent: this })
    ).addField(
      new FHardshipReasonFMiniFormMDP({
        taskRoot: this.taskRoot,
        parent: this,
      })
    );

    this.addField(
      new FIncomeSourcesFBudgetMiniFormMDP({
        taskRoot: this.taskRoot,
        parent: this,
      })
    )
      .addField(
        new FDebtRepaymentsMiniFormMDP({
          taskRoot: this.taskRoot,
          parent: this,
        })
      )
      .addField(
        new FIEUnsecuredDebtFBudgetMiniFormMDP({
          taskRoot: this.taskRoot,
          parent: this,
        })
      )
      
      .addField(
        new FLivingExpensesFBudgetMiniFormMDP({
          taskRoot: this.taskRoot,
          parent: this,
        })
      )
      .addField(
        new FLifeStyleExpensesFBudgetMiniFormMDP({
          taskRoot: this.taskRoot,
          parent: this,
        })
      )
      .addField(
        new FDependentExpensesFBudgetMiniFormMDP({
          taskRoot: this.taskRoot,
          parent: this,
        })
      )
      .addField(
        new FIncidentalExpensesFBudgetMiniFormMDP({
          taskRoot: this.taskRoot,
          parent: this,
        })
      )
      .addField(
        new FMiscExpensesFBudgetMiniFormMDP({
          taskRoot: this.taskRoot,
          parent: this,
        })
      );
  }

  getMyRef() {
    return this.parent.getMyRef()[0].$refs[this.myRefName];
  }
}
